/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { ViewModel } from '../../core/viewmodel/ViewModel';
import { StoreProvider } from '../../stores/StoreProvider';
import { MaterialSnackbar } from '../../models/material/MaterialSnackbar';
import { SnackbarKey, OptionsObject } from 'notistack';
import * as H from 'history';

export class SnackbarViewModel extends ViewModel {
	public displayed: SnackbarKey[] = [];

	public snackbar: MaterialSnackbar = new MaterialSnackbar();

	public readonly enqueueSnackbar: (message: string | React.ReactNode, options?: OptionsObject) => SnackbarKey;

	public readonly closeSnackbar: (notification: SnackbarKey) => void;

	public removeNotification(key: SnackbarKey): void {
		this.snackbar.removeNotification(key);
	}

	public removeClosedNotification(key: SnackbarKey): void {
		this.snackbar.removeClosedNotification(key);
	}

	constructor(storeProvider: StoreProvider, history: H.History, snackbar: SnackbarViewModel) {
		super(storeProvider, history);
		this.enqueueSnackbar = snackbar.enqueueSnackbar;
		this.closeSnackbar = snackbar.closeSnackbar;

		storeProvider.snackbarStore.registerSnackbar(this.snackbar);
	}
}
